import { getFormattedPotency, getPotencyValues, isPotencyProduct, imageToUse } from 'shared/helpers/products';
import { Product } from './product-card.types';

type GetPotencyStringsReturn = {
  THC: string | null;
  CBD: string | null;
  TAC: string | null;
};

type UseProductCardReturn = {
  name: string;
  imageUrl: string;
  prices: number[] | null;
  brandName: string | null;
  strainType?: string | null;
  potency: string[];
};

const getPotencyStrings = (product: Product): GetPotencyStringsReturn => {
  const potencyValues = getPotencyValues(product);
  const potencyStrings = getFormattedPotency(product);
  const showTHC = isPotencyProduct(product) && parseFloat(potencyValues.THC) > 0;
  const showCBD = isPotencyProduct(product) && parseFloat(potencyValues.CBD) > 0;
  const showTAC = isPotencyProduct(product) && parseFloat(potencyValues.TAC) > 0;
  return {
    THC: showTHC ? potencyStrings.THC : null,
    CBD: showCBD ? potencyStrings.CBD : null,
    TAC: showTAC ? potencyStrings.TAC : null,
  };
};

export const useProductCard = (product: Product): UseProductCardReturn => {
  const brandName = product.brand?.name;
  const strainType = product.strainType !== 'N/A' ? product.strainType : null;

  const productForPotencyHelpers = product.thcContent
    ? { ...product, THCContent: product.thcContent, CBDContent: product.cbdContent }
    : product;
  const { THC: THCString, CBD: CBDString, TAC: TACString } = getPotencyStrings(productForPotencyHelpers);
  const showTAC = !!product.cannabinoidsV2?.length;
  const potency: string[] = [];

  if (showTAC && typeof TACString === 'string') {
    potency.push(`TAC: ${TACString}`);
  }

  if (typeof THCString === 'string') {
    potency.push(`THC: ${THCString}`);
  }

  if (typeof CBDString === 'string') {
    potency.push(`CBD: ${CBDString}`);
  }

  const imageUrl = imageToUse(product);

  const prices = product.Prices?.filter((price): price is number => Number.isFinite(price)) ?? null;

  return {
    name: product.Name ?? '',
    imageUrl,
    prices,
    brandName: brandName ?? null,
    strainType,
    potency,
  };
};
